import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement } from 'react';
import classnames from 'classnames';
import styles from './PaymentPill.module.scss';
export const PaymentPill = ({ children, className, text, ...restProps }) => {
    return (_jsx("div", { className: classnames('d-flex', styles.paymentLabel, className), ...restProps, children: cloneElement(children, {
            className: classnames('p-0-5x', styles.paymentImg, {
                'text-uppercase d-flex align-items-center justify-content-center user-select-none w-auto': text,
            }, 
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
            children.props.className),
        }) }));
};
